import '/assets/css/main.css';
import '/assets/css/beitritt.css';
import jQuery from 'jquery';
import { StringTool } from '../tools/StringTool';
import { BeitrittData, BeitrittResponse } from './BeitrittData';

export class Beitritt {

    constructor() {

        let headers: [string, string][] = [["content-type", "text/json"]];

        let $response = $('#response');
        let $responsetext = $('#responsetext');
        let $mainDiv = $('#maindiv');

        $response.hide();
        $mainDiv.show();

        jQuery('#sendButton').on('click', async () => {

            $response.hide();

            let request: BeitrittData = this.getRequest();


            let response1 = await fetch('servlet/beitrittserklaerung', {
                method: "POST",
                body: JSON.stringify(request),
                headers: headers
            })

            let response: BeitrittResponse = await response1.json();

            $response.show();
            $mainDiv.hide();

            if (response.status == 'OK') {
                $response.css('color', 'black');
                $('.xlok').show();
                $('.xlerror').hide();

                let typ = $('#typ').val();
                let nichtZahlend = typ != 'zahlend';
                if(!nichtZahlend){
                    alert('Im Falle zahlender Mitglieder benötigen wir\neine schriftliche Einzugsermächtigung. Nachfolgend wird sich ein\nFenster mit der ausgefüllten Beitrittserklärung öffnen. \nWir möchten Sie bitten,\nsie auszudrucken und uns per Post zuzusenden.');
                    this.copyValuesToPrintPreview();
                    window.print();
                }

            } else {
                $response.css('color', '#800000');
                $('.xlok').hide();
                $('.xlerror').show();
            }

            $responsetext.text(response.message);


        });

        jQuery('#backButton').on('click', () => {
            $response.hide();
            $mainDiv.show();
        });

        jQuery('.beitritt-form-outline>div>input').on('input', () => {
            this.validate();
        })

        jQuery('.beitritt-form-outline>div>select').on('change', () => {
            this.validate();
        })

        this.validate();
    }

    validate() {
        let r = this.getRequest();
        this.setValid($('#rufname'), r.rufname?.length > 0);
        this.setValid($('#anrede'), r.anrede?.length > 0);
        this.setValid($('#familienname'), r.familienname?.length > 0);
        this.setValid($('#strasse'), r.strasse?.length > 0);
        this.setValid($('#plz'), r.plz?.length > 0);
        this.setValid($('#wohnort'), r.wohnort?.length > 0);
        this.setValid($('#geburtsdatum'), r.geburtsdatum?.length > 0);
        this.setValid($('#mail'), r.mail?.length > 0);
        this.setValid($('#abiturjahrgang'), r.abiturjahrgang != null && r.abiturjahrgang > 1930 && r.abiturjahrgang < 2100);

        let typ = $('#typ').val();
        let nichtZahlend = typ != 'zahlend';
        this.setValid($('#kreditinstitut'), r.kreditinstitut?.length > 0 || nichtZahlend);
        this.setValid($('#iban'), r.iban?.length > 0 || nichtZahlend);
        this.setValid($('#bic'), r.bic?.length > 0 || nichtZahlend);

        if (nichtZahlend) {
            $('#sendButton').text('Beitrittserklärung abschicken ...');
            $('#bankverbindungpanel').hide();
        } else {
            $('#sendButton').text('Beitrittserklärung abschicken und drucken ...');
            $('#bankverbindungpanel').show();
        }
    }

    isChecked(id: string) {
        let field = $('#' + id);
        if (field.length == 0) return false;
        return field.is(':checked');
    }

    inputFieldHasText(id: string): boolean {
        let field = $('#' + id);
        if (field.length == 0) return false;
        let value: string = "" + <string>field.val();
        return value.length > 0;
    }

    setValid($element: JQuery<HTMLInputElement>, isValid: boolean) {
        $element.toggleClass('is-valid', isValid);
        $element.toggleClass('is-invalid', !isValid);
    }

    getAsFloat(id: string): number {
        let field = $('#' + id);
        if (field.length == 0) return 0;
        let s = field.val() + "";
        if (s.length == 0) return 0;
        try {
            return Number.parseFloat(s.replace(",", "."));
        } catch (ex) {
            return 0;
        }
    }

    getAsInt(id: string): number {
        let field = $('#' + id);
        if (field.length == 0) return 0;
        let s = field.val() + "";
        if (s.length == 0) return 0;
        try {
            return Number.parseInt(s);
        } catch (ex) {
            return 0;
        }
    }

    getRequest(): BeitrittData {
        return {
            id: -1,
            anrede: <string>$('#anrede').val(),
            rufname: <string>$('#rufname').val(),
            familienname: <string>$('#familienname').val(),
            geburtsname: <string>$('#geburtsname').val(),
            akademischerGrad: <string>$('#akadgrad').val(),
            abiturjahrgang: this.getAsInt('abiturjahrgang'),
            strasse: <string>$('#strasse').val(),
            plz: <string>$('#plz').val(),
            wohnort: <string>$('#wohnort').val(),
            mail: <string>$('#mail').val(),
            geburtsdatum: <string>$('#geburtsdatum').val(),
            beruf: <string>$('#beruf').val(),
            vereinsbeitrag: this.getAsFloat('vereinsbeitrag'),
            typ: <any><string>$('#typ').val(),
            kreditinstitut: <string>$('#kreditinstitut').val(),
            iban: <string>$('#iban').val(),
            bic: <string>$('#bic').val(),
            speicherungErlaubt: this.isChecked('speicherung1ja'),
            abwinhaber: <string>$('#abwinhaber').val(),
        }
    }

    copyValuesToPrintPreview(){
        $('#p_name').text($('#rufname').val() + " " + $('#akadgrad').val() + " " + $('#familienname').val());
        $('#p_abwinhaber').text(<string>$('#abwinhaber').val());
        $('#p_strasse').text(<string>$('#strasse').val());
        $('#p_plzwohnort').text(<string>$('#plz').val() + " " + $('#wohnort').val());
        $('#p_mail').text(<string>$('#mail').val());

        let gd = <string>$('#geburtsdatum').val();
        if(gd){
            let d = new Date(gd);
            let date = d.getDate() + "." + (d.getMonth() + 1) + "." + d.getFullYear();
            $('#p_geburtsdatum').text(date);
        }

        $('#p_beruf').text(<string>$('#beruf').val());
        
        let beitrag = this.getAsFloat('vereinsbeitrag');
        if(!beitrag || beitrag < 30) beitrag = 30;
        $('#p_vereinsbeitrag').text("" + beitrag + " €");

        $('#p_kreditinstitut').text(<string>$('#kreditinstitut').val());
        $('#p_iban').text(<string>$('#iban').val());
        $('#p_bic').text(<string>$('#bic').val());
    }

}

new Beitritt();